import React, { ReactNode, useContext } from 'react';

import { Context } from '../Context/StoreLocatorContext';
import BladeContainer from '../../UI/BladeContainer/BladeContainer';

interface Props {
  children?: ReactNode;
}

const Blade = ({ children }: Props) => {
  const { bladeState, setBladeState } = useContext(Context);

  return (
    <BladeContainer
      bladeState={bladeState}
      setBladeState={setBladeState}
      addDivider
      bladeWidth={767}
    >
      {children}
    </BladeContainer>
  );
};

export default Blade;
